module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 58
// module chunks = 0